import 'metismenujs/dist/metismenujs.css';
import React from "react";
import { NavLink,useLocation } from 'react-router-dom'
import MetisMenu from '@metismenu/react';
import { DashboardIcon, TagsIcon, WorkFlowIcon } from "../iconshere";
import { useSelector } from "react-redux";
const Sitenav = () => {
    const userData = useSelector((state) => state.userSlice);
    const groupUuid = userData.user.group.uuid;

    const location = useLocation();

    return (
        <>
            <div className="vertical-menu">
                <div data-simplebar className="h-100">
                    <div id="sidebar-menu" style={{ marginTop: "20px" }}>
                        <MetisMenu activeLinkFromLocation>
                            <li>
                                <NavLink to={`/dashboard/${groupUuid}`} activeClassName='mm-active' exact>
                                    <DashboardIcon />
                                    <span className="ms-3">Dashboard</span> </NavLink>
                            </li>
                            <li>
                                <NavLink to={`/tags/${groupUuid}`} activeClassName='mm-active' exact>
                                    <TagsIcon />
                                    <span className="ms-3">Tag</span> </NavLink>
                            </li>
                            <li>
                                <NavLink to={`/workflows/${groupUuid}`} activeClassName='mm-active' exact>
                                    <WorkFlowIcon />
                                    <span className="ms-3">Workflow</span> </NavLink>
                            </li>
                        </MetisMenu>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sitenav;